import { Injectable } from "@angular/core";
import DateBox from "devextreme/ui/date_box";
import ListBox from "devextreme/ui/list";
import NumberBox from "devextreme/ui/number_box";
import Popup from "devextreme/ui/popup";
import RadioGroup from "devextreme/ui/radio_group";
import SelectBox from "devextreme/ui/select_box";
import TagBox from "devextreme/ui/tag_box";
import TextArea from "devextreme/ui/text_area";
import TextBox from "devextreme/ui/text_box";
import Chart from "devextreme/viz/chart";
import Funnel from "devextreme/viz/funnel";
import PieChart from "devextreme/viz/pie_chart";
import CheckBox from "devextreme/ui/check_box";
import LoadPanel from "devextreme/ui/load_panel";
import DropDownButton from "devextreme/ui/drop_down_button";
import TreeList from "devextreme/ui/tree_list";
import { DeviceDetectorService } from "ngx-device-detector";
import { AppInjector } from "../injector/injector.module";
import { SetGridDefaults } from "@base/grid/Grid.defaults";
import { FrameworkService } from "./framework.service";
import { RC } from "./resources.service";
import globalConfig from "devextreme/core/config"
import { SysGlobals } from './sysglobals';
import { EnumLanguages } from './sysenums.enum';
import repaintFloatingActionButton from 'devextreme/ui/speed_dial_action/repaint_floating_action_button';
import dxValidator from "devextreme/ui/validator";
import { BottomSheetService } from './bottom-sheet.service';
import { Utils } from '../helpers/Utils';

@Injectable()
export class DevExpressService {
    //Load DevExpress stuff
    public InitializeDevExpress(framework: FrameworkService) {
        var Detector = AppInjector.get(DeviceDetectorService);


        //Defaults for grid
        SetGridDefaults();

        this.SetFloatingButtonsDefault();

        //Defaults for textboxes  
        TextBox.defaultOptions
            ({
                options:
                {
                    valueChangeEvent: 'input',
                    inputAttr: { autocomplete: 'new-password' },
                    onFocusIn: !Detector.isDesktop() ? undefined : (e) => this.OnFocusIn(e),
                    onKeyDown: !Detector.isDesktop() ? undefined : (e) => this.OnChangeInputDirection(e),
                    validationMessageMode: 'always',
                    stylingMode: 'underlined',
                    onContentReady: (e) => {
                        const element = e?.component?.element();
                        element && element.addEventListener('wheel', (e) => {
                            e?.preventDefault();
                            e?.stopPropagation();
                        });
                    }
                }
            });

        TextArea.defaultOptions
            ({
                options:
                {
                    valueChangeEvent: 'input',
                    autoResizeEnabled: true,
                    stylingMode: 'underlined',
                    //minHeight: 30,
                    onFocusIn: !Detector.isDesktop() ? undefined : (e) => this.OnFocusIn(e),
                    onKeyDown: !Detector.isDesktop() ? undefined : (e) => this.OnChangeInputDirection(e),
                    validationMessageMode: 'always'
                }
            });


        //Defaults for numbertboxes
        NumberBox.defaultOptions
            ({
                options:
                {
                    step: 0,
                    onFocusIn: !Detector.isDesktop() ? undefined : (e) => this.OnFocusIn(e),
                    stylingMode: 'underlined',
                    onKeyDown: (e) => {
                        if (e.event.code === 'ArrowDown' || e.event.code === 'ArrowUp') {
                            e.event.preventDefault();
                            e.event.stopImmediatePropagation();
                        }
                    },
                    validationMessageMode: 'always'
                }
            });

        //Set default options for dates
        DateBox.defaultOptions
            ({
                options:
                {
                    type: "date",
                    pickerType: Detector.isMobile() || Detector.isTablet() ? "native" : "calendar",
                    displayFormat: framework.CompanyInfo.DateFormatLong,
                    useMaskBehavior: true,
                    min: "1900-01-01",
                    max: "2100-12-31",
                    stylingMode: 'underlined',
                    calendarOptions: { showTodayButton: true },
                    dropDownOptions: { container: ".app-container" },
                    onOpened: (e: any) => {
                        const todayButton = this.GetDateBoxTodayButton(e);
                        todayButton && todayButton.addEventListener('click', () => this.OnCloseDateBox(e));
                    },
                    onClosed: (e) => {
                        const todayButton = this.GetDateBoxTodayButton(e);
                        todayButton && todayButton.removeEventListener('click', () => this.OnCloseDateBox(e));
                    },
                    onKeyDown: (e) => {
                        if (e.event.code === 'ArrowDown' || e.event.code === 'ArrowUp') {
                            e.event.preventDefault();
                            e.event.stopImmediatePropagation();
                        }      
                    },
                    validationMessageMode: 'always'
                },
            });




        //Set default options for select boxes
        SelectBox.defaultOptions
            ({
                options:
                {
                    inputAttr: { autocomplete: 'new-password' },
                    displayExpr: "Text",
                    valueExpr: "Value",
                    placeholder: "",
                    stylingMode: 'underlined',
                    dropDownOptions: { container: ".app-container" },
                    searchTimeout: 100, //Without this, tabbing works bad since value is not looked up
                    onOpened: (e: any) => this.ShowBottomSheetList(e, false),
                    validationMessageMode: 'always'
                }
            });


        //Set default options for select boxes
        TagBox.defaultOptions(
            {
                options:
                {
                    displayExpr: "Text",
                    valueExpr: "Value",
                    noDataText: RC("genNoData"),
                    placeholder: "",
                    showSelectionControls: true,
                    multiline: false,
                    stylingMode: 'underlined',
                    maxDisplayedTags: Detector.isDesktop() ? 8 : 4,
                    applyValueMode: "useButtons",
                    dropDownOptions: { container: ".app-container" },
                    onOpened: (e: any) => this.ShowBottomSheetList(e, true),
                    validationMessageMode: 'always'
                }
            });

        //Set default options for list boxes
        ListBox.defaultOptions
            ({
                options:
                {
                    displayExpr: "Text",
                    valueExpr: "Value",
                    noDataText: RC("genNoData"),
                    pageLoadMode: 'scrollBottom',
                    activeStateEnabled: false,
                    stylingMode: 'underlined',
                    searchTimeout: 500,
                    validationMessageMode: 'always'
                }
            });


        //Set default options for select boxes
        RadioGroup.defaultOptions
            ({
                options:
                {
                    displayExpr: "Text",
                    valueExpr: "Value",
                    layout: "horizontal",
                    validationMessageMode: 'always'
                }
            });


        //Basically just for messageboxes
        Popup.defaultOptions
            ({
                options:
                {
                    showTitle: true,
                    showCloseButton: true,
                    dragEnabled: false,
                    closeOnOutsideClick: true,
                    container: ".app-container"
                }
            });




        PieChart.defaultOptions
            ({
                options:
                {
                    animation:
                    {
                        duration: 3000
                    },
                    resolveLabelOverlapping: 'shift',
                    type: 'doughnut',
                    palette: 'Soft Blue',
                    legend:
                    {
                        visible: Detector.isDesktop()
                    },
                    title:
                    {
                        font:
                        {
                            size: '16px',
                            weight: 600
                        }
                    },
                    tooltip:
                    {
                        enabled: Detector.isDesktop()
                    }
                }
            });

        Chart.defaultOptions
            ({
                options:
                {
                    animation:
                    {
                        duration: 3000
                    },
                    palette: 'Soft Blue',
                    legend:
                    {
                        visible: Detector.isDesktop()
                    },
                    title:
                    {
                        horizontalAlignment: "center",
                        font:
                        {
                            size: '16px',
                            weight: 600
                        }
                    },
                    tooltip:
                    {
                        enabled: Detector.isDesktop()
                    },

                    argumentAxis:
                    {
                        label:
                        {
                            overlappingBehavior: 'rotate',
                            rotationAngle: 270
                        }
                    }
                }
            });

        Funnel.defaultOptions
            ({
                options:
                {
                    palette: 'Soft Blue',
                    legend:
                    {
                        visible: false
                    },
                    title:
                    {
                        horizontalAlignment: "center",
                        font:
                        {
                            size: '16px',
                            weight: 600
                        }
                    },
                    tooltip:
                    {
                        enabled: Detector.isDesktop()
                    },
                }
            });

        CheckBox.defaultOptions
            ({
                options:
                {
                    onInitialized: function () {
                        if ((this as any)._options.option('value') == null) {
                            (this as any)._options.option('value', false);
                        }
                    },
                    validationMessageMode: 'always'
                }
            });

        LoadPanel.defaultOptions
            ({
                options:
                {
                    showIndicator: true,
                    showPane: true,
                    shading: true,
                    message: RC('msgLoading'),
                    shadingColor: 'rgba(0,0,0,0.4)'
                }
            });

        DropDownButton.defaultOptions
            ({
                options:
                {
                    showArrowIcon: Detector.isDesktop()
                }
            });

        TreeList.defaultOptions ({
            options: {
                showBorders: true
            }
        })

        dxValidator.defaultOptions({
            options: {
                validationRules: [{
                    type: 'required',
                    message: RC('errorRequiredMessage')
                }]
            }
        });
    }

    public SetFloatingButtonsDefault() {
        globalConfig({
            floatingActionButtonConfig: {
                icon: 'menu',
                position: SysGlobals.Language == EnumLanguages.Hebrew
                    ? {
                        at: 'left bottom',
                        my: 'left bottom',
                        offset: '16 -16'
                    }
                    : undefined
            }
        });

        repaintFloatingActionButton();
    }

    private OnFocusIn(e) {
        var oElement = e.element.querySelector('input');
        if (oElement != undefined) oElement.select()
    }

    private OnChangeInputDirection(e) {
        let event = e.event;
        if (event.ctrlKey && event.key === "Shift") {
            var bRTL = event.location === 2 ? true : false;
            e.component.option('rtlEnabled', bRTL);
            e.component.option('inputAttr',
                {
                    class: bRTL ? 'm4u-force-text-right' : 'm4u-force-text-left',
                    dir: bRTL ? 'rtl' : 'ltr'
                });
            e.component.focus();
        }
    }

    private GetDateBoxTodayButton(e: any) {
        const popupContentId = e.component && e.component._popupContentId;
        return popupContentId && document.querySelector(`#${popupContentId}.dx-popup-content .dx-calendar-today-button`);
    }

    private OnCloseDateBox(e: any) {
        e.component && e.component.close();
    }

    private ShowBottomSheetList(e, isMultiSelection: boolean) {
        // Open as default select-box if it is Desktop view
        const detector = AppInjector.get(DeviceDetectorService);
        if (detector.isDesktop()) return;
        // Open as usual if dropDownOptions.showAsBottomSheet = false
        const dropDownOptions = e.component.option('dropDownOptions');
        if (dropDownOptions && dropDownOptions.hasOwnProperty('showAsBottomSheet') && !dropDownOptions.showAsBottomSheet) return;
        // Hide default select-box
        (document.querySelector('.dx-selectbox-popup-wrapper .dx-overlay-content') as any).style.display = 'none';
        // Open as bottom sheet
        const bottomSheetService = AppInjector.get(BottomSheetService);
        const dataSource =  e.component.option('dataSource') || e.component.option('items');
        bottomSheetService.ShowList(e.component.option('placeholder'), dataSource, isMultiSelection, e.component.option('valueExpr'), e.component.option('displayExpr'))
            .subscribe((result) => { !Utils.IsEmpty(result) && e.component.option('value', result); });
    }
}
